// src/types/permissions.js

// 権限の種類定義
export const PERMISSIONS = {
    // ページ関連
    PAGES_VIEW: 'pages.view',
    PAGES_CREATE: 'pages.create',
    PAGES_EDIT: 'pages.edit',
    PAGES_DELETE: 'pages.delete',
    PAGES_PUBLISH: 'pages.publish',

    // メディア関連
    MEDIA_VIEW: 'media.view',
    MEDIA_UPLOAD: 'media.upload',
    MEDIA_DELETE: 'media.delete',

    // 設定関連
    SETTINGS_VIEW: 'settings.view',
    SETTINGS_EDIT: 'settings.edit',

    // サブドメイン関連
    SUBDOMAIN_VIEW: 'subdomain.view',
    SUBDOMAIN_EDIT: 'subdomain.edit',

    // ユーザー管理関連（管理ユーザーのみ）
    USERS_VIEW: 'users.view',
    USERS_INVITE: 'users.invite',
    USERS_EDIT_PERMISSIONS: 'users.edit_permissions',
    USERS_REMOVE: 'users.remove'
};

// 権限のカテゴリ分け（UI表示用）
export const PERMISSION_CATEGORIES = {
    pages: {
        name: 'ページ管理',
        permissions: [
            PERMISSIONS.PAGES_VIEW,
            PERMISSIONS.PAGES_CREATE,
            PERMISSIONS.PAGES_EDIT,
            PERMISSIONS.PAGES_DELETE,
            PERMISSIONS.PAGES_PUBLISH
        ]
    },
    media: {
        name: 'メディア管理',
        permissions: [
            PERMISSIONS.MEDIA_VIEW,
            PERMISSIONS.MEDIA_UPLOAD,
            PERMISSIONS.MEDIA_DELETE
        ]
    },
    settings: {
        name: '設定',
        permissions: [
            PERMISSIONS.SETTINGS_VIEW,
            PERMISSIONS.SETTINGS_EDIT
        ]
    },
    subdomain: {
        name: 'サブドメイン',
        permissions: [
            PERMISSIONS.SUBDOMAIN_VIEW,
            PERMISSIONS.SUBDOMAIN_EDIT
        ]
    },
    users: {
        name: 'ユーザー管理',
        permissions: [
            PERMISSIONS.USERS_VIEW,
            PERMISSIONS.USERS_INVITE,
            PERMISSIONS.USERS_EDIT_PERMISSIONS,
            PERMISSIONS.USERS_REMOVE
        ]
    }
};

// 権限の表示名
export const PERMISSION_LABELS = {
    [PERMISSIONS.PAGES_VIEW]: 'ページを表示',
    [PERMISSIONS.PAGES_CREATE]: 'ページを作成',
    [PERMISSIONS.PAGES_EDIT]: 'ページを編集',
    [PERMISSIONS.PAGES_DELETE]: 'ページを削除',
    [PERMISSIONS.PAGES_PUBLISH]: 'ページを公開',

    [PERMISSIONS.MEDIA_VIEW]: 'メディアを表示',
    [PERMISSIONS.MEDIA_UPLOAD]: 'メディアをアップロード',
    [PERMISSIONS.MEDIA_DELETE]: 'メディアを削除',

    [PERMISSIONS.SETTINGS_VIEW]: '設定を表示',
    [PERMISSIONS.SETTINGS_EDIT]: '設定を編集',

    [PERMISSIONS.SUBDOMAIN_VIEW]: 'サブドメイン情報を表示',
    [PERMISSIONS.SUBDOMAIN_EDIT]: 'サブドメイン設定を編集',

    [PERMISSIONS.USERS_VIEW]: 'ユーザー一覧を表示',
    [PERMISSIONS.USERS_INVITE]: 'ユーザーを招待',
    [PERMISSIONS.USERS_EDIT_PERMISSIONS]: 'ユーザー権限を編集',
    [PERMISSIONS.USERS_REMOVE]: 'ユーザーを削除'
};

// ユーザーロール
export const USER_ROLES = {
    ADMIN: 'admin',     // 管理ユーザー（全権限）
    EDITOR: 'editor'    // 編集ユーザー（制限付き権限）
};

// 管理ユーザーのデフォルト権限（すべて）
export const ADMIN_DEFAULT_PERMISSIONS = Object.values(PERMISSIONS);

// 編集ユーザーのデフォルト権限（基本的な表示権限のみ）
export const EDITOR_DEFAULT_PERMISSIONS = [
    PERMISSIONS.PAGES_VIEW,
    PERMISSIONS.MEDIA_VIEW,
    PERMISSIONS.SETTINGS_VIEW,
    PERMISSIONS.SUBDOMAIN_VIEW
];




